module.exports = __webpack_public_path__ + "static/media/testimonial-contestant-placeholder.684dd4ae.svg";